import { FC } from 'react'
import { withHeaderHOC } from 'shared/HOCs/withHeaderHOC'
import { withSideBarHOC } from 'shared/HOCs/withSidebarHOCs'
import { ReservationInterface } from 'widgets/ReservationInterface'
import { DaysOff } from 'widgets/_Accordions/DaysOff'
import { Schedule } from 'widgets/_Accordions/Schedule'
import { URLBuilderAccordion } from 'widgets/_Accordions/URLBuilder'

export const TableReservationComponent: FC = () => {
  return (
    <>
      {/* TODO: fix order */}
      <ReservationInterface />
      <URLBuilderAccordion />
      <DaysOff />
      <Schedule />
    </>
  )
}

// TODO: translations
export const TableReservation = withSideBarHOC(
  withHeaderHOC(TableReservationComponent, 'Table reservation')
)
